import { z } from 'zod'
import type { EphemeralStorePersistence } from '~/interfaces/EphemeralStorePersistence'
import type { EphemeralStorePersistenceOptions } from '~/interfaces/EphemeralStorePersistenceOptions'
import { createSchemaStorage } from '~/utils/createSchemaStorage'

export function createEphemeralStorePersistence<TValue>({
  key,
  schema,
  lifetimeMs,
  now = Date.now
}: EphemeralStorePersistenceOptions<TValue>): EphemeralStorePersistence<TValue> {
  const storage = createSchemaStorage({
    key,
    schema: z.object({ value: schema, expiresAt: z.number() })
  })

  const write = (value: TValue): void => {
    storage.write({ value, expiresAt: now() + lifetimeMs })
  }

  const read = (): TValue | undefined => {
    const record = storage.read()
    if (record === undefined) return undefined
    if (now() >= record.expiresAt) {
      storage.clear()
      return undefined
    }
    return record.value
  }

  return { read, write }
}
